module.exports = __webpack_public_path__ + "static/img/science1.71780567.png";